import { Component, OnInit, ViewChild } from '@angular/core';
import { IonicApp, Nav } from 'ionic-angular';
import { LifeCycleServiceProvider } from '../modules/core/services/life-cycle-service/life-cycle-service';

@Component({
  templateUrl: 'app.html',
})
export class MyApp implements OnInit {
  @ViewChild(Nav) nav: Nav;

  constructor(private ionicApp: IonicApp, private lifeCycleService: LifeCycleServiceProvider) {}

  ngOnInit() {
    this.lifeCycleService.initialize(this.ionicApp, this.nav);
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts